import React, { useEffect, useState } from "react";
import { Menu, Dropdown } from 'antd';
import styles from "./scss/numbertyping.module.scss";
import { URInput } from "../../../shared/widgets/input";
import backimg from "../../../styles/images/dialdelete.svg";
import store from "../../../context/store/store";
import { updateDirectNumber } from "../../../base/callService/callsApiService";
import _ from "lodash";
import Tooltip from "antd/es/tooltip";

type DialInputsProps = {
  keyVal: string;
  keyBoardEvent: Function;
  keyBoardBackSpace: Function;
  callerName: string;
};
type DialInputState = {
  defaultOne: string
}

export default function DialInputs({ keyVal, keyBoardEvent, keyBoardBackSpace, callerName }: DialInputsProps) {

  const [getItem, setItem] = useState<DialInputState>({ defaultOne: '' });
  let direct_number = store.getState().directNumberDetail?.list || [];
  const getDirectNumber = (directNumber: string) => {
    updateDirectNumber(directNumber);
    setItem({ ...getItem, defaultOne: directNumber });

  };

  useEffect(() => {
    setItem({ ...getItem, defaultOne: findDefault?.external_number });

  }, []);
  const findDefault=  direct_number?.find((num:any) => {return ( num?.is_default === 1 )})||direct_number[0];
  
  const menu = (
    <Menu className="yournumbers" >
      {direct_number.map((elem: any, index: number) => {
        return (
          ((direct_number.length > 0) &&
              <Menu.Item key={index} onClick={() => getDirectNumber(elem.external_number)}>
                <div className="listnumbersec">
               {getItem?.defaultOne===elem?.external_number&& <span className="icon_tick"></span>}
                  <p> <label>{elem.assigned_to === "Switchboard Number" ? "Company Number" : "DID Number"}</label>{elem?.external_number}</p>
                </div>
              </Menu.Item>
              
             
          ));
      })}
    </Menu>
  );
  const textBoxOnchange = (keyPress: any) => { keyBoardEvent(keyPress.target.value); };
  const textBoxBackSpace = () => { keyBoardBackSpace(); };

  return (
    <>
      <div className={` ${styles.dialpadmain} callfadein`}>
        <h3> {callerName}</h3>
        <URInput name="" className={styles.dialnumbers} value={keyVal} onChange={textBoxOnchange} maxLength={17} />
        <div className='testing123' onClick={textBoxBackSpace} id='dialRemove'>
          <img src={backimg} alt="" className={styles.backimg} /></div>
        {(direct_number?.length > 1) &&
          <h4>Your Number <Dropdown  trigger={['click']} overlay={menu} placement="bottomCenter">
            <div className={styles.dropitems}>{getItem.defaultOne}
             <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span>
            </div>
          </Dropdown></h4>
       }
       {(direct_number?.length===1) &&
          <h4>Your Number 
            <Tooltip placement="right" title="SwitchBoard Number"><div className={styles.dropitems}>{getItem.defaultOne}</div></Tooltip>
          </h4>
       }
        

      </div>
    </>
  );
};

